import React, {useEffect, useState} from 'react';
// import {Carousel, CarouselControl, CarouselItem,} from 'reactstrap';
import d1 from "../../assets/img/revamp/vibernets/landing/D1.jpg"
import d2 from "../../assets/img/revamp/vibernets/landing/D2.jpg"
import d3 from "../../assets/img/revamp/vibernets/landing/D3.jpg"
import d4 from "../../assets/img/revamp/vibernets/landing/D4.jpg"

import m1 from "../../assets/img/revamp/vibernets/landing/M1.jpg"
import m2 from "../../assets/img/revamp/vibernets/landing/M2.jpg"
import m3 from "../../assets/img/revamp/vibernets/landing/M3.jpg"
import m4 from "../../assets/img/revamp/vibernets/landing/M4.jpg"
import {Carousel} from "react-responsive-carousel";

let items = [
    {
        src: d1,
        altText: 'Slide 1',
        caption: 'Slide 1',
        key: 1,
    },
    {
        src: d2,
        altText: 'Slide 2',
        caption: 'Slide 2',
        key: 2,
    },
    {
        src: d3,
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 3,
    },
    {
        src: d4,
        altText: 'Slide 4',
        caption: 'Slide 4',
        key: 4,
    },
];

const itemsMobile = [
    {
        src: m1,
        altText: 'Slide 1',
        caption: 'Slide 1',
        key: 1,
    },
    {
        src: m2,
        altText: 'Slide 2',
        caption: 'Slide 2',
        key: 2,
    },
    {
        src: m3,
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 3,
    },
    {
        src: m4,
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 4,
    },
];

function LandingBanner(args) {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Update window width in state on resize
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 1200;

    let landingImages = [];

    if (windowWidth <= 680) {
        landingImages = itemsMobile;

    } else {
        landingImages = items;
    }

    return (
        <Carousel autoPlay={true} infiniteLoop={true} showStatus={false} showArrows={true} showThumbs={false}>
            {
                landingImages.map((item, index) => {
                    return <img key={item.key} alt={"d1"} src={item.src} style={{objectFit: "contain"}}/>
                })
            }
        </Carousel>
    );


    // const [activeIndex, setActiveIndex] = useState(0);
    // const [animating, setAnimating] = useState(false);
    //
    // const next = () => {
    //     if (animating) return;
    //     const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    //     setActiveIndex(nextIndex);
    // };
    //
    // const previous = () => {
    //     if (animating) return;
    //     const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    //     setActiveIndex(nextIndex);
    // };
    //
    // const goToIndex = (newIndex) => {
    //     if (animating) return;
    //     setActiveIndex(newIndex);
    // };

    // const slides = items.map((item) => {
    //     return (
    //         <CarouselItem
    //             className={""}
    //             onExiting={() => setAnimating(true)}
    //             onExited={() => setAnimating(false)}
    //             key={item.key}
    //         >
    //             <img src={item.src} width={'100%'} style={{objectFit: 'cover', borderRadius: 0}} alt={item.altText}/>
    //             {/*<CarouselCaption*/}
    //             {/*    captionText={item.caption}*/}
    //             {/*    captionHeader={item.caption}*/}
    //             {/*/>*/}
    //         </CarouselItem>
    //     );
    // });

    // return (
    //     <Carousel
    //         activeIndex={activeIndex}
    //         next={next}
    //         previous={previous}
    //         {...args}
    //     >
    //         {/*<CarouselIndicators*/}
    //         {/*    style={{backgroundColor:'maroon'}}*/}
    //         {/*    items={items}*/}
    //         {/*    activeIndex={activeIndex}*/}
    //         {/*    onClickHandler={goToIndex}*/}
    //         {/*/>*/}
    //         {slides}
    //         <CarouselControl
    //             direction="prev"
    //             directionText="Previous"
    //             onClickHandler={previous}
    //         />
    //         <CarouselControl
    //             direction="next"
    //             directionText="Next"
    //             onClickHandler={next}
    //         />
    //     </Carousel>
    // );
}

export default LandingBanner;